import { ChangeEventHandler } from 'react'
import { Checkbox, TableCell, TableRow, useTheme } from '@mui/material'

import { ConnectionCell, LinkCell } from './cells'
import { MediaImageRender } from 'src/components/media-input/media-image-render.component'
import { useMe } from 'src/hooks'
import { IMediaListItem } from 'src/types'
import { UtcAndLocalDatesCell } from 'src/components/utc-and-local-dates-cell'

import { useStyles } from './styles'

interface IProps {
  row: IMediaListItem
  isItemSelected: (id: string) => boolean
  handleItemCheck: (id: string) => ChangeEventHandler<HTMLInputElement>
}

export const TBodyRow = ({ row, isItemSelected, handleItemCheck }: IProps) => {
  const { data: user } = useMe()
  const classes = useStyles()

  const theme = useTheme()

  return (
    <TableRow
      sx={{
        borderTop: `1px solid ${theme.palette.custom.grey}`,
        borderBottom: `1px solid ${theme.palette.custom.grey}`,
        'td, th': { border: 0, cursor: 'default', p: '16px 8px' },
      }}
    >
      <TableCell align="center">
        <Checkbox
          checked={isItemSelected(row.id)}
          onChange={handleItemCheck(row.id)}
          sx={{ color: theme.palette.custom.grey2 }}
        />
      </TableCell>
      <TableCell>
        <ConnectionCell connection={row.connection} />
      </TableCell>
      <TableCell>{row.title}</TableCell>
      <TableCell>
        <LinkCell
          id={row.id}
          small={row.link_small}
          medium={row.link_medium}
          large={row.link_large}
          link={row.link}
          width={Number(row.dimensions?.split('x')[0])}
          height={Number(row.dimensions?.split('x')[1])}
          size={row.size}
          size_large={row.size_large}
          size_medium={row.size_medium}
          size_small={row.size_small}
        />
      </TableCell>
      <TableCell align="center">{row.type}</TableCell>
      <TableCell align="center">
        <MediaImageRender
          type={row.type}
          link={row.link_medium || row.link}
          alt={row.title}
          className={classes.image}
        />
      </TableCell>
      <TableCell align="center">
        <UtcAndLocalDatesCell date={row.created_at} loalTimezone={user?.timezone} />
      </TableCell>
      <TableCell align="center">
        <UtcAndLocalDatesCell date={row.updated_at} loalTimezone={user?.timezone} />
      </TableCell>
      <TableCell />
    </TableRow>
  )
}
